// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //urlApi: 'https://apim-apimg-dev.azure-api.net',
  urlApi: 'https://garantias.stage.bancodeoccidente.com.co',
  backendServicesInquieresGet: "/trade-banking/bank-guarantee/v1/internal/inquires/bank-guarantee-data",
  OcpApimSubscriptionKey: '2f891dba916a458893b9ba1a3b9850af',
  xAppId: "515",
  xChannel: "Canales Digitales",
  xCompanyId: "0023",
  xGovIssueIdentType: "CC",
  xIdentSerialNum: "123456789"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
